import { InjectionToken } from "@angular/core";

export const PB_THEME_STORAGE_KEY_TOKEN = new InjectionToken<string>(
	"Theme storage key",
);
